import { render, staticRenderFns } from "./cstudentFinish.vue?vue&type=template&id=229c9e26"
import script from "./cstudentFinish.vue?vue&type=script&lang=js"
export * from "./cstudentFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports